import React from "react";
import Home from "../jsx/components/Dashboard/Home";
import OrganizationList from "../admin/admincomponent/organization/OrganizationList";
import IndividualList from "../admin/admincomponent/Individual/IndividualList";
import IndividualVerificationForm from "../admin/admincomponent/Individual/IndividualVerificationForm";
import OrganizationVerficationForm from "../admin/admincomponent/organization/OrganizationVerficationForm";
import VerifiedUserList from "../admin/admincomponent/verifiedUser/VerifiedUserList";
import ViewUser from "../admin/admincomponent/verifiedUser/ViewUser";
import InsituteViewUser from "../admin/admincomponent/verifiedUser/InsituteViewUser";
import InsituteVeriedUserList from "../admin/admincomponent/verifiedUser/InsituteVeriedUserList";
import Communication from "../admin/admincomponent/communication/Communication";
import CommunicationList from "../admin/admincomponent/communication/CommunicationList";
import WebsiteNotification from "../admin/admincomponent/communication/WebsiteNotification/WebsiteNotification";
import Ticket from "../admin/admincomponent/ticket/Ticket";
import EventCalendar from "../admin/admincomponent/eventCalendar/EventCalendar";
import DSO from "../admin/admincomponent/dso/DSO";
import { DSOProvider } from "../context/DSOContext";
import UserNotification from "../jsx/components/Users/UserNotification";
import EditProfileRequestList from "../admin/admincomponent/editProfile/EditProfileRequestList";
import EditProfileRequestView from "../admin/admincomponent/editProfile/EditProfileRequestView";
import AccountManagement from "../admin/admincomponent/accountManagement/AccountManagement";
import { AccountManagementProvider } from "../context/AccountManagementContext";
import AccountProfileManagement from "../admin/admincomponent/accountManagement/AccountProfileManagement";
import AccountRoleManagement from "../admin/admincomponent/accountManagement/accountRole/AccountRoleManagement";
import AccountAddRoleMangement from "../admin/admincomponent/accountManagement/accountRole/AccountAddRoleMangement";
import AssignUserList from "../admin/admincomponent/accountManagement/accountRole/AssignUserList";
import MenuManagement from "../admin/admincomponent/menuManagement/MenuManagement";
import { MenuManagementProvider } from "../context/MenuManagementContext";
import Error503 from "../jsx/pages/Error503";
import { allVenueManagerroutes } from "./VenueManager";
import NewDashboard from "../admin/admincomponent/NewDashboard/newDashboard";

// MISSING MODULES COMMENTED OUT
// import RedireactionComponent from "../admin/admincomponent/redireactionComponent/RedireactionComponent";
// import Index from "../admin/admincomponent/BatchManagement/Batches/Index";
// import Calendar from "../admin/admincomponent/BatchManagement/Calendar/Index";
// import CreateBatch from "../admin/admincomponent/BatchManagement/Batches/CreateBatch";
// import ViewBatch from "../admin/admincomponent/BatchManagement/Batches/ViewBatch";
// import CreateTraining from "../admin/admincomponent/BatchManagement/Calendar/CreateTraining";
// import AcademyDashboard from "../admin/admincomponent/BatchManagement/Dashboard/index";
// import Accreditation from "../jsx/components/Users/Acceradation";

// OUR NEW IMPORTS
import ProfileComp from "../admin/admincomponent/Profile/ProfileComp";
import Certificate from "../jsx/components/Users/Certificate";
import Accreditation from "../jsx/components/Users/Accreditation"
import PublicGrievance from "../jsx/components/Users/PublicGrievance";
import RegistrationList from "../admin/admincomponent/registration/RegistrationList";


export const adminRoutes = [
  { url: "", component: <OrganizationList /> },
  { url: "dashboard", component: <NewDashboard /> },
  { url: "Organization", component: <OrganizationList /> },
  { url: "Individual", component: <IndividualList /> },
  { url: "registration", component: <RegistrationList /> },

  // OUR NEW ROUTES
  { url: "profile", component: <ProfileComp /> },
  { url: "Certificate", component: <Certificate /> },
  { url: "Accreditation", component: <Accreditation /> },

  { url: "verification-form/:id", component: <OrganizationVerficationForm roleWiseType="insitute" roletype="2" /> },
  { url: "verification-Individual-form/:id", component: <IndividualVerificationForm roleWiseType="individual" roletype="1" /> },
  { url: "verified-institute-user", component: <InsituteVeriedUserList roletype="2" roleCategory="insitute" /> },
  { url: "verified-individual-user", component: <VerifiedUserList roletype="1" roleCategory="individual" /> },
  { url: "verification-view-form/:id", component: <ViewUser /> },
  { url: "verification-insitute-view-form/:id", component: <InsituteViewUser /> },
  { url: "communication/communication-list", component: <CommunicationList /> },
  { url: "communication/website-notification-list", component: <WebsiteNotification /> },
  { url: "edit-profile-requests", component: <EditProfileRequestList /> },
  { url: "edit-profile-request-view/:id", component: <EditProfileRequestView /> },
];

export const allAdminroutes = [
  ...adminRoutes,
  { url: "manage-dso", component: <DSOProvider><DSO /></DSOProvider> },
  { url: "communication", component: <Communication /> },
  // { url: "redirection_url", component: <RedireactionComponent /> },
  { url: "communication/communication-list", component: <CommunicationList /> },
  { url: "grievance-management/ticket", component: <Ticket /> },
  { url: "grievance-management/notification", component: <UserNotification /> },
  { url: "grievance-management", component: <Ticket /> },
      { url: "public-grievance", component: <PublicGrievance /> },

  { url: "communication/website-notification-list", component: <WebsiteNotification /> },
  { url: "event/event-calendar", component: <EventCalendar /> },
  { url: "menu-management/menu", component: <MenuManagement /> },

  // BATCH MANAGEMENT ROUTES COMMENTED OUT
  // { url: "batch-management/dashboard", component: <AcademyDashboard /> },
  // { url: "batch-management/batches", component: <Index /> },
  // { url: "batch-management/batches/add", component: <CreateBatch /> },
  // { url: "batch-management/batches/viewBatch/:id", component: <ViewBatch /> },
  // { url: "batch-management/batches/update/:id", component: <CreateBatch /> },
  // { url: "batch-management/calendar", component: <Calendar /> },
  // { url: "batch-management/calendar/create-training", component: <CreateTraining /> },
  // { url: "batch-management/calendar/update/:id", component: <CreateTraining /> },

  { url: "account/accountmanagement", component: <AccountManagement /> },
  { url: "account/account-profile/:id", component: <AccountProfileManagement /> },
  { url: "account/role", component: <AccountRoleManagement /> },
  { url: "account/role/add", component: <AccountAddRoleMangement /> },
  { url: "account/role/update/:id", component: <AccountAddRoleMangement /> },
  { url: "account/role-assign/:id", component: <AssignUserList /> },
  ...allVenueManagerroutes
];